import type { LocationQuery } from 'vue-router'
import router from '@/router'
import { buildLocationQuery } from '@/features/shared/tools'
import type { PagedRequest } from './storeRechercheBuilder'
import type { StoreDefinition } from 'pinia'

export type RechercherParser<TRequest extends object> = (query: LocationQuery) => PagedRequest<TRequest>

export function buildRechercheRoutingService<TRequest extends object>(
  useStoreRecherche: StoreDefinition,
  parseLocationQuery: (query: LocationQuery) => PagedRequest<TRequest>,
) {
  const store = useStoreRecherche()

  async function loadStoreFromLocationQuery(query: LocationQuery): Promise<boolean> {
    const pageRequest = parseLocationQuery(query)
    try {
      await store.loadData(pageRequest)
      return true
    } catch {
      return false
    }
  }

  function loadPageWithPagedRequest(request: PagedRequest<TRequest>) {
    // construire url
    const newQuery = buildLocationQuery({
      ...request.query,
      orderBy: request.orderBy,
      ...request.pagination,
    })
    const route = request.route
      ? { ...request.route, query: newQuery }
      : { ...router.currentRoute.value, query: newQuery }
    router.push(route as any)
  }

  return { loadStoreFromLocationQuery, loadPageWithPagedRequest }
}

